export enum ServerSideCampaignStatus {
	Active = 'Active',
	Inactive = 'Inactive'
}

export type TemplatePropertiesValue = {
	name: string, value: string, isGroup?: boolean, isCollection?: boolean
}

export type CreateServerSideCampaignApiType = {
	baseTemplateId: string | null;
	name: string;
	recommendationConfiguration: RecommendationConfigurationApiType | null;
	templateProperties: Array<TemplatePropertiesValue>;
}
/*
type ServerSideCampaignEditorApiType = {
	id: string | null;
	name: string;
	recommendationConfiguration?: RecommendationConfigurationApiType | null;
}
*/
export type RecommendationConfigurationApiType = {
	tenant: string | null;
	ruleId: string;
	numberOfProducts: number;
}


export type UpdateServerSideCampaignApiType = {
	name: string | null;
	status: ServerSideCampaignStatus | null;
	recommendationConfiguration: RecommendationConfigurationApiType | null;
	templateProperties: Array<TemplatePropertiesValue> | null;
}

// SaaS Formats

export type ServerSideSaaSFormatProductRecommendationsParams = {
	productUrlConfigurationParameterName: string;
	productImageConfigurationParameterName: string;
	numberOfProductsConfigurationParameterName: string;
}

export type ServerSideSaaSFormatParams = {
	productRecommendationsParams?: ServerSideSaaSFormatProductRecommendationsParams | null;
}

export type ServerSideSaaSFormatApiType = {
	thumbnailUrl: string;
	id: string;
	name: string;
	description: string;
	templateName: string;
	properties: any;
	wysiwyg: { template: string; };
	params: ServerSideSaaSFormatParams;
}


export type ServerSideCampaignDetailApiType = {
	id: string;
	name: string;
	status: ServerSideCampaignStatus;
	templateProperties: TemplatePropertiesValue[];
	recommendationConfiguration: RecommendationConfigurationApiType | null;
	saaSFormat: ServerSideSaaSFormatApiType;
}


export const payloadExample: ServerSideSaaSFormatApiType[] = [
	{
		params: {
			productRecommendationsParams: {
				numberOfProductsConfigurationParameterName: 'PRODUCTS_COUNT',
				productImageConfigurationParameterName: 'IMAGE_BASE_URL',
				productUrlConfigurationParameterName: 'PRODUCT_BASE_URL'
			}
		},
		id: '6c642286-8e2c-4cd9-8da7-fae1a746b15f',
		thumbnailUrl: 'https://beyabledev.blob.core.windows.net/displaylibrary/ba14e9e3-bbcd-49d4-8c7d-34e6ede2bbf8/thumbnails/229a5312089b4b74976bd24a19db94b0.png?sv=2023-01-03&st=2024-09-09T06%3A17%3A37Z&se=2025-09-10T06%3A17%3A00Z&sr=c&sp=rl&sig=XKKS7YkZrUn1Nojivc6zhUosJqQPv7U0zeqLV88ru0Q%3D',
		name: 'Email widget',
		description: 'Email widget',
		templateName: 'EM_G_0001_RECO',		
		properties: [
			{
				'Name': 'RECOMMENDATION_SELECTOR',
				'FriendlyName': 'Recommendation',
				'Editor': {
					'Type': 'ProductRecommendations'
				}
			},
			{
				'Name': 'CONTAINER',
				'FriendlyName': 'Size & margin',
				'Editor': {
					'Type': 'Group'
				},
				'Content': [
					{
						'Name': 'AVAILABLE_WIDTH',
						'Value': 600,
						'FriendlyName': 'Available width',
						'Description': 'Adjust the available width to preview the final rendering on email',
						'Device': 'desktop',
						'Editor': {
							'Type': 'Range',
							'Min': 200,
							'Max': 1900,
							'Unit': 'px'
						}
					},
					{
						'Name': 'AVAILABLE_WIDTH_MOB',
						'Value': 480,
						'FriendlyName': 'Available width',
						'Description': 'Adjust the available width to preview the final rendering on email',
						'Device': 'mobile',
						'Editor': {
							'Type': 'Range',
							'Min': 100,
							'Max': 1000,
							'Unit': 'px'
						}
					},
					{
						'Name': 'SEP_01',
						'Value': '',
						'Editor': {
							'Type': 'Separator'
						}
					},
					{
						'Name': 'HAS_MARGIN',
						'FriendlyName': 'Active outer margins',
						'Device': 'desktop',
						'Value': false,
						'Editor': {
							'Type': 'Boolean'
						}
					},
					{
						'Name': 'MARGIN_TOP',
						'Value': 16,
						'FriendlyName': 'Margin top',
						'Device': 'desktop',
						'Editor': {
							'Type': 'Range',
							'Min': 0,
							'Max': 100,
							'Unit': 'px',
							'Width': 'm',
							'Float': true
						},
						'Dependency': {
							'Property': 'CONTAINER.HAS_MARGIN',
							'Value': true
						}
					},
					{
						'Name': 'MARGIN_RIGHT',
						'Value': 0,
						'FriendlyName': 'Margin right',
						'Device': 'desktop',
						'Editor': {
							'Type': 'Range',
							'Min': 0,
							'Max': 200,
							'Unit': 'px',
							'Width': 'm',
							'Float': true
						},
						'Dependency': {
							'Property': 'CONTAINER.HAS_MARGIN',
							'Value': true
						}
					},
					{
						'Name': 'MARGIN_BOTTOM',
						'Value': 16,
						'FriendlyName': 'Margin bottom',
						'Device': 'desktop',
						'Editor': {
							'Type': 'Range',
							'Min': 0,
							'Max': 100,
							'Unit': 'px',
							'Width': 'm',
							'Float': true
						},
						'Dependency': {
							'Property': 'CONTAINER.HAS_MARGIN',
							'Value': true
						}
					},
					{
						'Name': 'MARGIN_LEFT',
						'Value': 0,
						'FriendlyName': 'Margin left',
						'Device': 'desktop',
						'Editor': {
							'Type': 'Range',
							'Min': 0,
							'Max': 200,
							'Unit': 'px',
							'Width': 'm',
							'Float': true
						},
						'Dependency': {
							'Property': 'CONTAINER.HAS_MARGIN',
							'Value': true
						}
					}
				]
			},
			{
				'Name': 'BACKGROUND',
				'FriendlyName': 'Background & Border',
				'Editor': {
					'Type': 'Group'
				},
				'Content': [
					{
						'Name': 'BG_COLOR',
						'Value': '#ffffff',
						'FriendlyName': 'Backgroud color',
						'Editor': {
							'Type': 'ColorPicker',
							'Width': 's',
							'Float': true
						}
					},
					{
						'Name': 'BORDER_RADIUS',
						'Value': 10,
						'FriendlyName': 'Border radius',
						'Editor': {
							'Type': 'Range',
							'Min': 0,
							'Max': 50,
							'Unit': 'px'
						}
					},
					{
						'Name': 'SEP_01',
						'Value': '',
						'Editor': {
							'Type': 'Separator'
						}
					},
					{
						'Name': 'HAS_BORDER',
						'Value': false,
						'FriendlyName': 'Border',
						'Editor': {
							'Type': 'Boolean'
						}
					},
					{
						'Name': 'BORDER_WIDTH',
						'Value': 2,
						'FriendlyName': 'Border width',
						'Dependency': {
							'Property': 'BACKGROUND.HAS_BORDER',
							'Value': true
						},
						'Editor': {
							'Type': 'Range',
							'Min': 1,
							'Max': 10,
							'Unit': 'px'
						}
					},
					{
						'Name': 'BORDER_COLOR',
						'Value': '#23B185',
						'FriendlyName': 'Border color',
						'Dependency': {
							'Property': 'BACKGROUND.HAS_BORDER',
							'Value': true
						},
						'Editor': {
							'Type': 'ColorPicker',
							'Width': 's'
						}
					}
				]
			},
			{
				'Name': 'TEXT_CONTENT',
				'FriendlyName': 'Header',
				'Editor': {
					'Type': 'Group'
				},
				'IsActiveProperty': {
					'Name': 'ISACTIVE',
					'Value': true
				},
				'Content': [
					{
						'Name': 'TEXT',
						'Value': '<p style="text-align: center; line-height: 1.5;"><span style="font-family: Montserrat; font-size: 18px;"><strong>Most popular products</strong></span></p><p style="text-align: center; line-height: 1.5;"><span style="font-size: 13px;"><span style="font-family: Montserrat; color: #34495e;">Discover our best-selling </span><span style="font-family: Montserrat; color: #34495e;">products</span></span></p>',
						'FriendlyName': 'Text',
						'Editor': {
							'Type': 'RichText'
						}
					}
				]
			},
			{
				'Name': 'PRODUCTS',
				'FriendlyName': 'Products',
				'Editor': {
					'Type': 'Group'
				},
				'Content': [
					{
						'Name': 'NB_PRODUCTS',
						'Value': 3,
						'FriendlyName': 'Number of products',
						'Editor': {
							'Type': 'Number',
							'Min': 1,
							'Max': 6
						}
					},
					{
						'Name': 'SHOW_PRICES',
						'Value': true,
						'FriendlyName': 'Show price',
						'Editor': {
							'Type': 'Boolean'
						}
					},
					{
						'Name': 'SHOW_DISCOUNT',
						'Value': true,
						'FriendlyName': 'Show discount',
						'Editor': {
							'Type': 'Boolean'
						},
						'Dependency': {
							'Property': 'PRODUCTS.SHOW_PRICES',
							'Value': true
						}
					},
					{
						'Name': 'TXT_COLOR',
						'Value': '#000000',
						'FriendlyName': 'Text color',
						'Editor': {
							'Type': 'ColorPicker',
							'Width': 'l',
							'Float': true
						}
					}
				]
			},
			{
				'Name': 'ADVANCED',
				'FriendlyName': 'Advanced options',
				'Editor': {
					'Type': 'Group'
				},
				'Content': [
					{
						'Name': 'BREAKPOINT',
						'Value': 768,
						'FriendlyName': 'Mobile breakpoint',
						'Description': 'Below what screen width the mobile version should be displayed?',
						'Editor': {
							'Type': 'Number',
							'Min': 400,
							'Max': 1100,
							'Unit': 'px'
						}
					}
				]
			}
		],
		wysiwyg: {
			template: '<style type="text/css">\n\thtml{\n\t\theight: 100%;\n\t}\n\tbody{\n\t\theight: 100%;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tposition: relative;\n\t}\n\tbody > .desktop,\n\tbody > .mobile{\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 20px;\n\t\tright: 20px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t}\n\tbody > .mobile{\n\t\tleft: 0px;\n\t\tright: 0px;\n\t\tbackground: #F5F6F8;\n\t}\n\t.page{\n\t\tflex: 1 1 auto;\n\t\tmargin: auto;\n\t}\n</style>\n<style type="text/css">{{Css}}</style>\n<style type="text/css">\n\n\t.by_EM_G_0001 .by_list {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\t/*overflow-x: auto;*/\n\t\t--nbProducts: {{PRODUCTS.NB_PRODUCTS}};\n\t}\n\t.by_EM_G_0001 .empty_list {\n\t\ttext-align: center;\n\t\tfont-size: 16px;\n\t\tcolor: #777;\n\t\tcolor: #9299a0;\n\t\tpadding: 70px 10px;\n\t}\n\t.by_EM_G_0001 .by_item {\n\t\tflex: 0 0 calc(100% / var(--nbProducts));\n\t\twidth: calc(100% / var(--nbProducts));\n\t}\n\n\t{% if CONTAINER.HAS_MARGIN == true %}\n\t\t.page{\n\t\t\tborder: dashed 1px #D5D5D5;\n\t\t}\n\t\t.by_EM_G_0001 .by_outer{\n\t\t\tpadding-top: {{CONTAINER.MARGIN_TOP}}px;\n\t\t\tpadding-right: {{CONTAINER.MARGIN_RIGHT}}px;\n\t\t\tpadding-bottom: {{CONTAINER.MARGIN_BOTTOM}}px;\n\t\t\tpadding-left: {{CONTAINER.MARGIN_LEFT}}px;\n\t\t}\n\t{% endif %}\n\n\t@media (min-width: {{ADVANCED.BREAKPOINT | plus: 1}}px){\n\t\t.by_mobile{\n\t\t\tdisplay: none;\n\t\t}\n\t\t.page{\n\t\t\tmax-width: {{CONTAINER.AVAILABLE_WIDTH}}px;\n\t\t}\n\n\t\t.by_EM_G_0001 .by_col_center{\n\t\t\tmargin-top: {{ BODY.MARGIN_TOP }}px;\n\t\t\tmargin-bottom: {{ BODY.MARGIN_BOTTOM }}px;\n\t\t\tmargin-left: {{ BODY.MARGIN_LEFT }}px;\n\t\t\tmargin-right: {{ BODY.MARGIN_RIGHT }}px;\n\t\t}\n\t}\n\n\t@media (max-width: {{ADVANCED.BREAKPOINT}}px){\n\t\t.by_desktop{\n\t\t\tdisplay: none;\n\t\t}\n\t\t.page{\n\t\t\tmax-width: {{CONTAINER.AVAILABLE_WIDTH_MOB}}px;\n\t\t}\n\n\t\t.by_EM_G_0001 .by_col_center{\n\t\t\tmargin-top: {{ BODY.MARGIN_TOP_MOB }}px;\n\t\t\tmargin-bottom: {{ BODY.MARGIN_BOTTOM_MOB }}px;\n\t\t\tmargin-left: {{ BODY.MARGIN_LEFT_MOB }}px;\n\t\t\tmargin-right: {{ BODY.MARGIN_RIGHT_MOB }}px;\n\t\t}\n\t}\n\n\t.by_EM_G_0001 .by_inner{\n\t\tbackground-color: {{BACKGROUND.BG_COLOR}};\n\t\tborder-radius: {{BACKGROUND.BORDER_RADIUS}}px;\n\t\t{% if BACKGROUND.HAS_BORDER %}\n\t\t\tborder-style: solid;\n\t\t\tborder-width: {{BACKGROUND.BORDER_WIDTH}}px;\n\t\t\tborder-color: {{BACKGROUND.BORDER_COLOR}};\n\t\t{% endif %}\n\t}\n\t\n\t.by_EM_G_0001 .by_item_inner {\n\t\tcolor: {{PRODUCTS.TXT_COLOR}};\n\t}\n</style>\n\n<div class="page">\n\t<div class="by_EM_G_0001">\n\t\t<div class="by_outer">\n\t\t\t<div class="by_inner">\n\t\t\t\t{% if TEXT_CONTENT.ISACTIVE %}\n\t\t\t\t\t<div class="by_title">{{TEXT_CONTENT.TEXT}}</div>\n\t\t\t\t{% endif %}\n\t\t\t\t<div class="by_list_wrapper">\n\t\t\t\t\t{% if RecommandationProducts == false or RecommandationProducts.size == 0 %}\n\t\t\t\t\t\t<div class="empty_list">Select a recommendation rule to display products</div>\n\t\t\t\t\t{% endif %}\n\t\t\t\t\t{% if RecommandationProducts %}\n\t\t\t\t\t\t<div class="by_list by-js-list">\n\t\t\t\t\t\t\t{% for p in RecommandationProducts limit:PRODUCTS.NB_PRODUCTS %}\n\t\t\t\t\t\t\t\t<div class="by_item by-js-item">\n\t\t\t\t\t\t\t\t\t<div class="by_item_inner">\n\t\t\t\t\t\t\t\t\t\t<img class="by_img by-js-img" src="{{p.ThumbnailUrl}}" width="250" height="250" />\n\t\t\t\t\t\t\t\t\t\t<div class="by_product_info">\n\t\t\t\t\t\t\t\t\t\t\t<div class="by_name by-js-name">{{p.Name}}</div>\n\t\t\t\t\t\t\t\t\t\t\t{% if PRODUCTS.SHOW_PRICES %}\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="by_price_info">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="by_price by-js-price">{{p.SellingPrice}}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t{% if PRODUCTS.SHOW_DISCOUNT and p.IsDiscounted and p.PriceBeforeDiscount %}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="by_old_price by-js-oldprice">{{p.PriceBeforeDiscount}}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t{% endif %}\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t{% endif %}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t{% endfor %}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t{% endif %}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n',
		}
	},
	{
		params: {
			productRecommendationsParams: {
				numberOfProductsConfigurationParameterName: 'PRODUCTS_COUNT',
				productImageConfigurationParameterName: 'IMAGE_BASE_URL',
				productUrlConfigurationParameterName: 'PRODUCT_BASE_URL'
			}
		},
		id: 'b3f132bd-7915-4074-b711-4b5d5581aa00',
		thumbnailUrl: 'https://az691294.vo.msecnd.net/assets/ba14e9e3-bbcd-49d4-8c7d-34e6ede2bbf8/logo-2c9e5687-306f-480c-b113-9d080e23073d.png',
		name: 'Reinsurance banner',
		description: 'Reinsurance banner',
		templateName: 'O_G_0004_POPIN_CTA',
		properties: [
			{
				Name: 'IMG',
				Device: 'desktop',
				FriendlyName: 'Image',
				Editor: {
					Type: 'Group'
				},
				IsActiveProperty: {
					Name: 'ISACTIVE',
					Value: true
				},
				Content: [
					{
						Name: 'IMG_SRC',
						Value: 'https://tag.beyable.com/assets/0000000a-0000-0000-0000-000000000000/logo-dc3757a5-cb46-42b2-a2e6-9811eb52d4d2.jpg',
						FriendlyName: 'Upload image locked',
						Editor: {
							Type: 'Image',
							CropRatio: {
								Height: 200,
								Width: 120,
								Locked: true
							}
						}
					},
					{
						Name: 'IMG_SRC_2',
						Value: 'https://tag.beyable.com/assets/0000000a-0000-0000-0000-000000000000/logo-dc3757a5-cb46-42b2-a2e6-9811eb52d4d2.jpg',
						FriendlyName: 'Upload image non-locked',
						Editor: {
							Type: 'Image',
							CropRatio: {
								Height: 200,
								Width: 120,
								Locked: false
							}
						}
					},
					{
						Name: 'IMG_SRC_3',
						Value: 'https://tag.beyable.com/assets/0000000a-0000-0000-0000-000000000000/logo-dc3757a5-cb46-42b2-a2e6-9811eb52d4d2.jpg',
						FriendlyName: 'Upload image free',
						Editor: {
							Type: 'Image',
						}
					},
					{
						Name: 'IMG_POSITION',
						Value: 'left',
						FriendlyName: 'Position',
						Editor: {
							Type: 'ButtonGroup',
							AvailableValues: [
								{
									Label: 'Left',
									Value: 'left'
								},
								{
									Label: 'Right',
									Value: 'right'
								}
							]
						}
					},
					{
						Name: 'IMG_WIDTH',
						Value: 290,
						FriendlyName: 'Width',
						Editor: {
							Type: 'Range',
							Min: 100,
							Max: 400,
							Unit: 'px'
						}
					},
					{
						Name: 'IMG_HEIGHT',
						Value: 400,
						FriendlyName: 'Height (minimum height)',
						Editor: {
							Type: 'Range',
							Min: 100,
							Max: 500,
							Unit: 'px'
						}
					}
				]
			},
			{
				Name: 'IMG_MOB',
				Device: 'mobile',
				FriendlyName: 'Image',
				Editor: {
					Type: 'Group'
				},
				IsActiveProperty: {
					Name: 'ISACTIVE',
					Value: true
				},
				Content: [
					{
						Name: 'IMG_SRC',
						Value: 'https://tag.beyable.com/assets/0000000a-0000-0000-0000-000000000000/logo-dc3757a5-cb46-42b2-a2e6-9811eb52d4d2.jpg',
						FriendlyName: 'Upload image',
						Editor: {
							Type: 'Image'
						}
					},
					{
						Name: 'IMG_HEIGHT',
						Value: 150,
						FriendlyName: 'Height (minimum height)',
						Editor: {
							Type: 'Range',
							Min: 60,
							Max: 300,
							Unit: 'px'
						}
					}
				]
			},
			{
				Name: 'HEADER',
				FriendlyName: 'Header',
				Editor: {
					Type: 'Group'
				},
				IsActiveProperty: {
					Name: 'ISACTIVE',
					Value: true
				},
				Content: [
					{
						Name: 'TEXT',
						Value: '<p><span style="font-size: 18px;"><strong>Nos client nous font confiance&nbsp;!</strong></span></p>',
						FriendlyName: 'Text',
						Device: 'desktop',
						Editor: {
							Type: 'RichText'
						}
					},
					{
						Name: 'TEXT_MOB',
						Value: '<p><span style="font-size: 16px;"><strong>Nos client nous font confiance&nbsp;!</strong></span></p>',
						FriendlyName: 'Text',
						Device: 'mobile',
						Editor: {
							Type: 'RichText'
						}
					},
					{
						Name: 'IS_UNDERLINE',
						Value: true,
						FriendlyName: 'Underline',
						Editor: {
							Type: 'Boolean'
						}
					},
					{
						Name: 'BORDER_COLOR',
						Value: '#E65540',
						FriendlyName: 'Underline color',
						Editor: {
							Type: 'ColorPicker',
							Width: 's',
							Float: true
						}
					}
				]
			},
			{
				Name: 'BODY',
				FriendlyName: 'Body',
				Editor: {
					Type: 'Group'
				},
				Content: [
					{
						Name: 'BG_COLOR',
						Value: '#FFFFFF',
						FriendlyName: 'Background color',
						Description: 'Test d\'une description assez longue pour voir',
						Editor: {
							Type: 'ColorPicker'
						}
					},
					{
						Name: 'BORDER_RADIUS',
						Value: 5,
						FriendlyName: 'Border radius',
						Editor: {
							Type: 'Range',
							Min: 0,
							Max: 50,
							Unit: 'px'
						}
					},
					{
						Name: 'ALIGN',
						Value: 'center',
						FriendlyName: 'Alignment',
						Editor: {
							Type: 'ButtonGroup',
							AvailableValues: [
								{
									Label: 'Left',
									Value: 'left'
								},
								{
									Label: 'Center',
									Value: 'center'
								},
								{
									Label: 'Right',
									Value: 'right'
								}
							]
						}
					},
					{
						Name: 'MAIN_TEXT',
						Value: '<p><span style="font-size: 16px;">Livraison <strong>rapide</strong></span></p><p><span style="font-size: 16px;">Service client <strong>disponible</strong></span></p><p><span style="font-size: 16px;">Retours <strong>gratuit</strong> sour 15 jours</span></p>',
						FriendlyName: 'Main text',
						Device: 'desktop',
						Editor: {
							Type: 'RichText'
						}
					},
					{
						Name: 'MAIN_TEXT_MOB',
						Value: '<p><span style="font-size: 14px;">Livraison <strong>rapide</strong></span></p><p><span style="font-size: 14px;">Service client <strong>disponible</strong></span></p><p><span style="font-size: 14px;">Retours <strong>gratuit</strong> sour 15 jours</span></p>',
						FriendlyName: 'Main text',
						Device: 'mobile',
						Editor: {
							Type: 'RichText'
						}
					},
					{
						Name: 'WIDTH',
						Device: 'desktop',
						Value: 410,
						FriendlyName: 'Width',
						Editor: {
							Type: 'Range',
							Min: 300,
							Max: 600,
							Unit: 'px'
						}
					},
					{
						Name: 'WIDTH_MOB',
						Device: 'mobile',
						Value: 310,
						FriendlyName: 'Width',
						Editor: {
							Type: 'Range',
							Min: 260,
							Max: 400,
							Unit: 'px'
						}
					},
					{
						Name: 'HEIGHT',
						Device: 'desktop',
						Value: 200,
						FriendlyName: 'Height (minimum height)',
						Editor: {
							Type: 'Range',
							Min: 200,
							Max: 600,
							Unit: 'px'
						}
					},
					{
						Name: 'HEIGHT_MOB',
						Device: 'mobile',
						Value: 160,
						FriendlyName: 'Height (minimum height)',
						Editor: {
							Type: 'Range',
							Min: 100,
							Max: 400,
							Unit: 'px'
						}
					}
				]
			},
			{
				Name: 'CTA',
				FriendlyName: 'Call to action',
				Editor: {
					Type: 'Group'
				},
				Content: [
					{
						Name: 'TEXT',
						Value: 'JE CONTINUE',
						FriendlyName: 'Text',
						Editor: {
							Type: 'Text'
						}
					},
					{
						Name: 'URL',
						Value: '',
						FriendlyName: 'Redirect URL',
						SubDescription: 'Leave empty to close popin',
						Editor: {
							Type: 'Text'
						}
					},
					{
						Name: 'NEW_TAB',
						Value: false,
						FriendlyName: 'Open in a new tab',
						Editor: {
							Type: 'Boolean'
						}
					},
					{
						Name: 'BG_COLOR',
						Value: '#E65540',
						FriendlyName: 'Background color',
						Editor: {
							Type: 'ColorPicker',
							Width: 'm',
							Float: true
						}
					},
					{
						Name: 'TXT_COLOR',
						Value: '#FFF',
						FriendlyName: 'Text color',
						Editor: {
							Type: 'ColorPicker',
							Width: 'm',
							Float: true
						}
					},
					{
						Name: 'BORDER_RADIUS',
						Value: 4,
						FriendlyName: 'Border radius',
						Editor: {
							Type: 'Range',
							Min: 0,
							Max: 50,
							Unit: 'px'
						}
					}
				]
			},
			{
				Name: 'CLOSE',
				FriendlyName: 'Close button',
				Editor: {
					Type: 'Group'
				},
				IsActiveProperty: {
					Name: 'ISACTIVE',
					Value: true
				},
				Content: [
					{
						Name: 'LABEL',
						Value: 'Fermer',
						FriendlyName: 'Text',
						Editor: {
							Type: 'Text'
						}
					},
					{
						Name: 'COLOR',
						Value: '#FFFFFF',
						FriendlyName: 'Color',
						Editor: {
							Type: 'ColorPicker',
							Width: 'm',
							Float: true
						}
					}
				]
			},
			{
				Name: 'OVERLAY',
				FriendlyName: 'Overlay',
				Editor: {
					Type: 'Group'
				},
				Content: [
					{
						Name: 'BG_COLOR',
						Value: 'rgba(0,0,0,.5)',
						FriendlyName: 'Backgroud color',
						Editor: {
							Type: 'ColorPicker',
							Width: 'l',
							Float: true
						}
					},
					{
						Name: 'CLICK_TO_CLOSE',
						Value: true,
						FriendlyName: 'Click on overlay to close popin',
						Editor: {
							Type: 'Boolean'
						}
					}
				]
			},
			{
				Name: 'TRACKING',
				FriendlyName: 'Tracking URLs',
				Tooltip: 'The tracking links can be set-up through affiliation platforms and they are used to trace the post-click conversions. All tracking links contain the affiliate\'s number, which allows the platform to attribute sales to the leverage that contributed to them. Tracking links are used for CPA (% commission on sale) or CPL (cost per lead) remuneration.',
				Editor: {
					Type: 'Group'
				},
				IsActiveProperty: {
					Name: 'ISACTIVE',
					Value: false
				},
				Content: [
					{
						Name: 'CLICK_CTA_URL',
						Value: '',
						FriendlyName: 'After clicking on call to action',
						Editor: {
							Type: 'Text'
						}
					}
				]
			}
		],
		wysiwyg: {
			template: '<style>\n{{Css}}\n\n.by_O_G_0004 {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: url(https://az691294.vo.msecnd.net/assets/ba14e9e3-bbcd-49d4-8c7d-34e6ede2bbf8/logo-111f5355-f559-49a6-aaba-3aec05d01344.png);\n    background-position: center top;\n    background-size: cover;\n}\n.by_O_G_0004 .by_popin{\n\tposition: absolute !important;\n\tz-index: 1 !important;\n\tvisibility: visible !important;\n\topacity: 1 !important;\n}\n\n.by_O_G_0004 .by_popin{\n\tbackground: {{OVERLAY.BG_COLOR}};\n}\n.by_O_G_0004 .by_popin_inner{\n\tbackground: {{BODY.BG_COLOR}};\n\tborder-radius: {{BODY.BORDER_RADIUS}}px;\n}\n@media (min-width: 769px){\n\t.by_O_G_0004 .by_body{\n\t\twidth: {{BODY.WIDTH}}px;\n\t\tmin-height: {{BODY.HEIGHT}}px;\n\t}\n}\n@media (max-width: 768px){\n\t.by_O_G_0004 .by_body{\n\t\twidth: {{BODY.WIDTH_MOB}}px;\n\t\tmin-height: {{BODY.HEIGHT_MOB}}px;\n\t}\n}\n.by_O_G_0004 .by_cta{\n\tbackground: {{CTA.BG_COLOR}};\n\tcolor: {{CTA.TXT_COLOR}};\n\tborder: solid 1px {{CTA.BG_COLOR}};\n\tborder-radius: {{CTA.BORDER_RADIUS}}px;\n}\n.by_O_G_0004 .by_close{\n\tcolor: {{CLOSE.COLOR}};\n}\n.by_O_G_0004 .by_img.by_desktop{\n\twidth: {{IMG.IMG_WIDTH}}px;\n\tmin-height: {{IMG.IMG_HEIGHT}}px;\n}\n.by_O_G_0004 .by_img.by_mobile{\n\tmin-height: {{IMG_MOB.IMG_HEIGHT}}px;\n}\n.by_O_G_0004 .by_img.by_desktop .by_img_inner{\n\tbackground-image: url({{IMG.IMG_SRC}});\n}\n.by_O_G_0004 .by_img.by_mobile .by_img_inner{\n\tbackground-image: url({{IMG_MOB.IMG_SRC}});\n}\n{% if HEADER.IS_UNDERLINE %}\n\t.by_O_G_0004 .by_text_header::after{\n\t\tborder-color: {{HEADER.BORDER_COLOR}};\n\t}\n{% else %}\n\t.by_O_G_0004 .by_text_header::after{\n\t\tdisplay: none;\n\t}\n{% endif %}\n</style>\n\n<div class="by_O_G_0004 by_is_open"\n     data-by_imageside="{{IMG.IMG_POSITION}}"\n     data-by_align="{{BODY.ALIGN}}">\n\t<div class="by_popin">\n\t\t<div class="by_popin_inner">\n\n\t\t\t{% if IMG.ISACTIVE %}\n\t\t\t\t<div class="by_img by_desktop">\n\t\t\t\t\t<div class="by_img_inner"></div>\n\t\t\t\t</div>\n\t\t\t{% endif %}\n\n\t\t\t{% if IMG_MOB.ISACTIVE %}\n\t\t\t\t<div class="by_img by_mobile">\n\t\t\t\t\t<div class="by_img_inner"></div>\n\t\t\t\t</div>\n\t\t\t{% endif %}\n\t\t\t\n\t\t\t<div class="by_body">\n\t\t\t\t<div class="by_body_middle">\n\t\t\t\t\t{% if HEADER.ISACTIVE %}\n\t\t\t\t\t\t<div class="by_text_header by_desktop">{{HEADER.TEXT}}</div>\n\t\t\t\t\t\t<div class="by_text_header by_mobile">{{HEADER.TEXT_MOB}}</div>\n\t\t\t\t\t{% endif %}\n\n\t\t\t\t\t<div class="by_text_main by_desktop">\n\t\t\t\t\t\t{{BODY.MAIN_TEXT}}\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="by_text_main by_mobile">\n\t\t\t\t\t\t{{BODY.MAIN_TEXT_MOB}}\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="by_cta_wrapper">\n\t\t\t\t\t\t<a class="by_cta">\n\t\t\t\t\t\t\t{{CTA.TEXT}}\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>',
		}
	},
];
